import PreloaderIcon from './preloaderIcon.svg';

import { memo } from 'react';

const Preloader: React.FC<{ className?: string }> = ({ className = '' }) => (
  <PreloaderIcon className={className} />
);

export default memo(Preloader);
